import {
	GET_COMPARE_REQUEST,
	GET_PARTIAL_COMPARE_REQUEST,
	GET_COMPARE_SUCCESS,
	GET_COMPARE_ERROR,
	ON_SHOW_DIFFERENCE,
	FEATURE_ORDER
} from 'constants/compareConstants';
import { LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import get from 'lodash/get';

export default function comparePageReducer(
	state = {
		asyncStatus: 'INIT',
		showDifference: false
	},
	action
) {
	switch (action.type) {
		case GET_COMPARE_REQUEST:
			return Object.assign({}, state, {
				asyncStatus: LOADING
			});
		case GET_PARTIAL_COMPARE_REQUEST:
			return Object.assign({}, state, {
				asyncStatus: 'PARTIAL_LOADING'
			});
		case GET_COMPARE_SUCCESS:
			return Object.assign(
				{},
				state,
				{
					asyncStatus: SUCCESS,
					showDifference: false
				},
				getComparePage(action.data)
			);
		case GET_COMPARE_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				error: action.error,
				showDifference: false
			});
		case ON_SHOW_DIFFERENCE:
			return Object.assign(
				{},
				state,
				{ showDifference: action.data },
				{ bodyData: combineReviews(getBodyOnlyDifferentCompare(state.fullBodyData, action.data)) },
				{ featureData: getFeaturesOnlyDifferentCompare(state.fullFeatureData, action.data) }
			);
		default:
			return state;
	}
}

function getComparePage(state) {
	const {
		impressionId,
		compareSummary,
		comparableFeatureList,
		productUrls,
		analyticsData: analyticsInfo,
		pageTitle
	} = state;
	const {
		images,
		productState,
		titles,
		productPricingSummary: price,
		isFlipkartAdvantage,
		addToCartWidgets,
		buyNowWidgets,
		...fullBodyData
	} = compareSummary;
	const topBarData = {
		images,
		productState,
		titles,
		price,
		isFlipkartAdvantage,
		productUrls,
		pageTitle,
		vertical: state.vertical
	};
	let bodyData = getBodyOnlyDifferentCompare(fullBodyData, false);
	bodyData = combineReviews(fullBodyData);
	const featureData = getFeaturesOnlyDifferentCompare(comparableFeatureList, false);
	const reviewData = {
		reviews: compareSummary.productReviews
	};

	return {
		topBarData,
		bodyData,
		fullBodyData: fullBodyData,
		fullFeatureData: comparableFeatureList,
		featureData,
		reviewData,
		analyticsInfo,
		buyNowWidgets,
		addToCartWidgets,
		featureOrder: FEATURE_ORDER,
		impressionId,
		pageTitle
	};
}

function combineReviews(bodyData) {
	const reviewValues = get(bodyData, ['productReviews', 'values']);
	const reviewWidgets = get(bodyData, ['reviewWidgets', 'values']);
	const reviewValuePids = reviewValues && Object.keys(reviewValues);
	const reviewWidgetsPids = reviewWidgets && Object.keys(reviewWidgets);
	let allReviews = {};
	if (reviewValuePids && reviewValuePids.length && reviewWidgetsPids && reviewWidgetsPids.length) {
		allReviews = reviewValuePids.reduce((allReviews, reviewValuePid) => {
			reviewWidgetsPids.forEach(reviewWidgetsPid => {
				if (reviewValuePid === reviewWidgetsPid) {
					allReviews[reviewValuePid] = {};
					allReviews[reviewValuePid]['type'] = 'allReviews';
					allReviews[reviewValuePid]['value'] = get(reviewValues, [reviewValuePid, 'value']);
					allReviews[reviewValuePid]['link'] = {
						title: get(reviewWidgets, [reviewValuePid, 'value', 'data', '0', 'value', 'title']),
						url: get(reviewWidgets, [reviewValuePid, 'value', 'data', '0', 'action', 'url'])
					};
				}
			});
			return allReviews;
		}, allReviews);
		bodyData['allReviews'] = {
			featureName: 'Ratings & Reviews',
			properties: {
				isDifferent: get(bodyData, ['productReviews', 'properties', 'isDifferent']) || false
			},
			values: allReviews
		};
	}

	return bodyData;
}

function getBodyOnlyDifferentCompare(fullBodyData, isShowDifference) {
	return Object.keys(fullBodyData).reduce((results, propKey) => {
		if (isShowDifference) {
			const isDifferent = get(fullBodyData[propKey], ['properties', 'isDifferent']);
			results[propKey] = isDifferent || propKey === 'reviewWidgets' ? fullBodyData[propKey] : null;
		} else {
			results[propKey] = fullBodyData[propKey];
		}
		return results;
	}, {});
}

function getFeaturesOnlyDifferentCompare(comparableFeatures, isShowDifference) {
	const nulledFeatures = comparableFeatures.map(f => {
		const newList = {
			featureList: f.featureList.filter(feature => {
				if (isShowDifference) {
					const isDifferent = get(feature, ['properties', 'isDifferent']);
					return isDifferent ? feature : null;
				}
				return feature;
			}),
			title: f.title
		};
		return newList;
	});
	return nulledFeatures.reduce((results, f) => {
		if (f.featureList.length) {
			results.push(f);
		}
		return results;
	}, []);
}

export function flattenOutHighlights(quickCompareData, productIds) {
	const { primaryImage, highlights, productPricingSummary, titles, productUrls } = quickCompareData;
	const newHighlights = {};
	const borderObj = { border: true };
	productIds.map(productId => {
		const productData = get(highlights, ['values', productId, 'value']);
		if (!productData) {
			return;
		}
		(productData.keySpecs || []).forEach((spec, key) => {
			const specKey = `spec${key}`;
			newHighlights[specKey] = newHighlights[specKey] || {
				values: {}
			};
			newHighlights[specKey].values[productId] = spec;
		});
		if (productData.warrantySummary) {
			newHighlights['warrantySummary'] = newHighlights['warrantySummary'] || {
				values: {}
			};
			newHighlights['warrantySummary'].values[productId] = productData.warrantySummary;
		}
		if (productData.returnPolicy) {
			newHighlights['returnPolicy'] = newHighlights['returnPolicy'] || {
				values: {}
			};
			newHighlights['returnPolicy'].values[productId] = productData.returnPolicy;
		}
	});
	return {
		primaryImage,
		borderObj,
		titles,
		productUrls,
		productPricingSummary,
		...newHighlights
	};
}
